/**
 * Merkzettel zwischen dem Anlegen einer Begehung und dem Pruefmodul.
 *
 * Der Folgebericht setzt alle Anwesenheiten zurueck (clearPresence) und wirft
 * die Gaeste weg — richtig so, aber danach steht im Protokoll niemand, und die
 * Teilnehmer werden auf der Baustelle regelmaessig nicht nachgetragen. Deshalb
 * oeffnet das Pruefmodul die Teilnehmerauswahl direkt nach dem Anlegen von
 * selbst; „Alleine" ist dort die ausdrueckliche Antwort und kein Uebersehen.
 *
 * Warum ein Modul-Zustand und kein Prop: der Weg fuehrt ueber eine
 * Ansichtsumschaltung in App.tsx (ProjectHub wird ausgehaengt, das Modul neu
 * gemountet) — ein Prop muesste durch zwei fremde Ebenen gefaedelt werden.
 * Der Merkzettel ueberlebt bewusst KEIN Neuladen der Seite: dann ist der
 * Zeitpunkt vorbei und ein Dialog aus dem Nichts waere nur laestig.
 *
 * Der Schluessel (Projekt + Berichtsnummer) verhindert, dass ein liegen
 * gebliebener Merker die Auswahl bei einem anderen Bericht aufreisst.
 */

let pending: string | null = null;

export const participantPromptKey = (projectId: string | undefined, inspectionNumber: number | undefined): string =>
    `${projectId || 'unknown'}:${inspectionNumber ?? 0}`;

/** Vormerken, dass fuer diesen Bericht die Teilnehmer noch erfasst werden muessen. */
export const markParticipantPrompt = (key: string): void => {
    pending = key;
};

/** Einmalig einloesen: true nur beim ersten Aufruf mit passendem Schluessel. */
export const consumeParticipantPrompt = (key: string): boolean => {
    if (pending === null || pending !== key) return false;
    pending = null;
    return true;
};

/** Nur fuer Tests und den Abbruchfall (Modul verlassen, ohne dass es aufging). */
export const clearParticipantPrompt = (): void => {
    pending = null;
};
